import axios from 'axios';
import { useState } from 'react';
import { useForm, useFieldArray, set } from 'react-hook-form';
import CONFIG from '../../constanta/config';
import LogoApp from '../../components/logoapp';
import InputSearchRegister from '../../components/input_search_register';
import Cookies from 'js-cookie';

const FormSearch = (props) => {
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      question: [{ question: '' }] // Start with one empty question field
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'question'
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAlertOepn, setIsAlertOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [msgerror, setMsgerror] = useState('');

  const onSubmit = (data) => {
    setMsg('');
    //setFormData(data); // Store the form data
    if (data.dob === selectedData.dob) {
      checkDataUser(data);
    } else {
      setMsg('Date of Birth does not match the selected user. Please contact us via email at admin@workscu.com to verify or update your member information.');
    }
  };

  const checkDataUser = (data) => {
    setLoading(true);

    const payload = {
      name: selectedData?.name
      //birth_date: selectedDOB,
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    axios
      .get(CONFIG.URL + '/user/' + selectedData?.id_user, {
        headers: {
          token: CONFIG.TOKEN_VOTING
        }
      })
      .then(function (response) {
        if (response?.data.status === 'SUCCESS') {
          props.handleSetUser(response?.data.data[0]);
          //response?.data?.data[0]
        } else {
          setMsgerror('User not found');
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const handleSuccessSearchAdd = (data) => {
    setSelectedData(data);
  };

  const clearAll = () => {
    setSelectedData(null);
    //setValue("code", "");
  };

  return (
    <>
      <div className="flex flex-col justify-start items-start w-full md:w-1/2">
        <div className="flex flex-col justify-start items-start space-y-2.5 w-full">
          <div className="mx-auto bg-white rounded-lg shadow-lg p-5 max-w-3xl w-full">
            <div className="flex justify-center mb-2">
              <LogoApp />
            </div>

            <div className="mb-4">
              {props.attendance === 'Trinidad' && (
                <div className=" flex flex-col justify-start items-center bg-gray-200 shadow-md text-black p-2 rounded-lg shadow  transition duration-300">
                  <h3 className="text-lg font-bold">TRINIDAD</h3>
                  <p className="text-sm mt-2  text-center">
                    Grand Ballroom at the Hilton Trinidad & Conference Centre
                    located at Lady Young Rd, Port of Spain
                  </p>
                </div>
              )}

              {props.attendance === 'Tobago' && (
                <div className="flex flex-col justify-start items-center bg-gray-200 shadow-md text-black p-2 px-4 rounded-lg shadow  transition duration-300">
                  <h3 className="text-lg font-bold">TOBAGO</h3>
                  <p className="text-sm mt-2  text-center">
                    Tobago Nutrition Co-operative Society's Banquet Hall located
                    at Milford Rd., Canaan
                  </p>
                </div>
              )}

              {props.attendance === 'Virtual' && (
                <div className="flex flex-col justify-start items-center bg-gray-200 shadow-md text-black p-2 px-4 rounded-lg shadow transition duration-300">
                  <h3 className="text-lg font-bold text-center">VIRTUAL</h3>
                  <p className="text-sm mt-2  text-center">
                    Zoom
                    <br />
                    Video Conferencing
                  </p>
                  <strong className="text-sm">
                    All Virtual Attendees must complete their Registration via
                    Zoom
                  </strong>
                </div>
              )}
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="mx-auto">
              <div className="w-full mt-6">
                <InputSearchRegister
                  onSuccess={(data) => handleSuccessSearchAdd(data)}
                  users={[]}
                  data={selectedData}
                  onClear={() => clearAll()}
                />
              </div>

              <div className="mb-6">
                <label
                  htmlFor="dob"
                  className="block text-sm font-medium text-gray-700">
                  Date of Birth
                </label>
                <input
                  id="dob"
                  name="dob"
                  type="date"
                  {...register('dob', {
                    required: 'Date of Birth is required'
                  })}
                  className={`mt-1 block w-full p-2 border ${
                    errors.dob ? 'border-red-500' : 'border-gray-300'
                  } rounded-md shadow-sm`}
                />
                {errors.dob && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.dob.message}
                  </p>
                )}
              </div>

              {msg !== '' && (
                <div className="text-center font-bold text-red-500 mb-2">
                  {msg}
                </div>
              )}

              <div className="flex space-x-4">
                <button
                  disabled={loading}
                  onClick={() => props.handleChangeState('menu')}
                  type="button"
                  className="w-full bg-red-500 text-white py-2 px-4 rounded-md shadow transition duration-300">
                  Cancel
                </button>
                <button
                 disabled={loading}
                  type="submit"
                  className="w-full bg-blue-500 text-white py-2 px-4 rounded-md shadow transition duration-300">
                  {loading ? 'Loading...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormSearch;
